export const moduleId = 'red-sale-collection';

export const state = {
    lists: {},//详情参数
    orglist: {},//账套列表
    costIsShow: false,//详情显示隐藏
    dialogzt: false,//账套显示隐藏
    flag: false,//是否可编辑
    orgId: '',
    isShow: true,
    id: '',
    isDeapproval: false,
    isRouter: false,
    routeSource: false,
    isAdd: true,
    abId: '',
    orderNo: '',
    customerList:[]
}
export const mutations = {
    setRedSaleIsAdd(state, flag) {
        state.isAdd = flag
    },
    // setRedSaleOrgId(state, id) {
    //     state.orgId = id
    // },
    // setRedSaleTaskId(state, data) {
    //     state.id = data.id
    //     state.abId = data.abId
    // },
    //反审批
    setRedSaleIsDeapproval(state, data) {
        state.isDeapproval = data
    },
    setRedSaleRouteSource(state, data) {
        state.routeSource = data
    },
    setRedSaleCostIsShow(state, data) {
        state.costIsShow = data
    },
    setRedSaleDialogzt(state, data) {
        state.dialogzt = data
    },
    setRedSaleOrgList(state, data) {
        state.lists = data
    },
    //账套列表
    setOrgList(state, data) {
        state.orglist = data
    },
    setRedSaleFalg(state, data) {
        state.flag = data
    },
    setRedSaleIsRouter(state, data) {
        state.isRouter = data
    },
    setOrderNo(state, data) {
        state.orderNo = data
    },
    setRedCustomerList(state, data) {
        state.customerList = data
    }
}
export const actions = {}


// WEBPACK FOOTER //
// ./src/store/modules/settlement-center/red-sale-collection/index.js